import { Box, Grid, IconButton, IconButtonProps, Tooltip, Typography } from "@mui/material";
import CustomAccordion from "../../../../../../../../components/accordion";
import { DestinationProps } from "./types";
import { icons } from "../../../../../../../../utils/icons";
import { CustomeIconButton } from "../../../../../../../../components/customeIconButton";
import { useTranslation } from "react-i18next";
import { useState } from "react";
import { useStyles } from "./styles";
import { CaptionKey } from "../../../../../../../../components/detailKeyValue/keyCaption.index";
import { Settings } from "../../../../../../../../components/settings";
import { useMenuDestination } from "../../../activityRegister/utils/hooks/menuDestination";



export const DestinationAccordion = ({ companyId, menuOption, companyName, createdDate, direction, id, isVisible, latitudeAndLongitude, name, userCreator, displayDestination, mapExpanded, storeId }: DestinationProps) => {
    const styles = useStyles()
    const { t } = useTranslation()
    const [expanded, setExpanded] = useState(false)
    const { menu } = useMenuDestination({ isUnity: storeId !== null })


    const visibility: Partial<IconButtonProps> = {
        color: 'primary',
        onClick: (e) => {
            e.stopPropagation();
            if (displayDestination) { displayDestination(id) };
        },
    };

    const toggleExpand = () => {
        setExpanded(!expanded)
    }


    return (
        <CustomAccordion
            title={(
                <Box sx={styles.alignHorizontal}>
                    <Box>
                        <Tooltip title={t(`ToolTips.${expanded ? 'collapse' : 'expand'}`)}>
                            <IconButton
                                onClick={(e) => {
                                    e.stopPropagation();
                                    toggleExpand();
                                }}
                                sx={[styles.arrow, styles.rotate(expanded)]}
                            >{icons('arrow-down')} </IconButton>
                        </Tooltip>

                        <Typography variant="subtitle_grey" fontWeight='bold'>{name}</Typography>
                    </Box>

                    <Box sx={styles.rightActions}>
                        <CustomeIconButton title={t(`general.${isVisible ? 'hiddenUser' : 'showUser'}`)} icon={icons(isVisible ? 'visibility' : 'visibility-off')} iconButtonProps={visibility} />

                        <Settings
                            //icon="moreVert"
                            /* iconProps={{
                                sx: styles.setting
                            }} */
                            menu={{
                                menuItems: menu,
                                click: (menu) => {
                                    if(menuOption){
                                        menuOption(menu, { companyId, companyName, createdDate, direction, id, latitudeAndLongitude, name, userCreator })
                                    }
                                }
                            }}
                        />
                    </Box>
                </Box>
            )}
            description={
                <>
                    <Grid container spacing={2}>
                        <Grid item xl={!mapExpanded ? 4 : 12} lg={mapExpanded ? 12 : 4} md={mapExpanded ? 12 : 6} sm={mapExpanded ? 12 : 6} xs={12}>
                            <CaptionKey caption={createdDate} value={t('loogbook.createdDate')} />
                        </Grid>

                        <Grid item xl={mapExpanded ? 12 : 4} lg={mapExpanded ? 12 : 4} md={mapExpanded ? 12 : 6} sm={mapExpanded ? 12 : 6} xs={12}>
                            <CaptionKey caption={userCreator} value={t('loogbook.userCreator')} />
                        </Grid>

                        <Grid item xl={mapExpanded ? 12 : 4} lg={mapExpanded ? 12 : 4} md={mapExpanded ? 12 : 6} sm={mapExpanded ? 12 : 6} xs={12}>
                            <CaptionKey caption={direction} value={t('loogbook.direction')} />
                        </Grid>

                        <Grid item xl={mapExpanded ? 12 : 4} lg={mapExpanded ? 12 : 4} md={mapExpanded ? 12 : 6} sm={mapExpanded ? 12 : 6} xs={12}>
                            <CaptionKey caption={latitudeAndLongitude} value={t('loogbook.latitudeAndLongitude')} />
                        </Grid>

                        <Grid item xl={mapExpanded ? 12 : 4} lg={mapExpanded ? 12 : 4} md={mapExpanded ? 12 : 6} sm={mapExpanded ? 12 : 6} xs={12}>
                            <CaptionKey caption={companyName} value={t('loogbook.company')} />
                        </Grid>

                    </Grid>
                </>
            }
            expandIcon={null}
            expanded={expanded}
        />

    )
}